export const servicios = {
    text1: "Lista zapytań o usługi",
    text2: "Zapytania złożone przez klientów",
    text3: "Lista zapytań",
    text4: "Wszystkie",
    text5: "Oczekujące",
    text6: "Zatwierdzone",
    text7: "Odrzucone",
    text8: "Opłacone",
    text9: "Usługa",
    text10: "Klient",
    text11: "Telefon",
    text12: "Utworzono",
    text13: "Status",
    text14: "Zobacz zamówienie",
    text15: "Zapytanie o usługę.",
    text16: "Dane zapytania",
    text17: "Data zapytania:",
    text18: " o",
    text19: "Informacje o usłudze",
    text20: "Cena:",
    text21: "Cena za:",
    text22: "Kategoria:",
    text23: "Dostawca:",
    text24: "Dostawca:",
    text25: "Usługa wewnętrzna",
    text26: "Informacje o usłudze",
    text27: "Nie znaleziono usługi",
    text28: "Informacje o zamawiającym",
    text29: "Telefon:",
    text30: "E-mail:",
    text31: "Rodzaj dokumentu:",
    text32: "Numer dokumentu:",
    text33: "Zamknij",
    text34: "Odrzuć",
    text35: "Zatwierdź",
    text36: "Potwierdź płatność",
    text37: "Odrzuć zapytanie",
    text38: "Zatwierdź zapytanie",
    text39: "Potwierdź płatność zamawiającego",
    text40: "Czy na pewno odrzucić zapytanie o usługę?",
    text41: "Przed zatwierdzeniem zapytania należy skontaktować się z zamawiającym",
    text42: "Potwierdzenie płatności zamawiającego zakończy cały proces",
    text43: "Odrzuć",
    text44: "Zatwierdź zapytanie",
    text45: "Płatność została już potwierdzona",
    text46: "Anuluj",
    text47: "Zaktualizowano pomyślnie.",

    // New labels  

    p1: `Dzisiaj`,
    p2: `Zamówiona usługa`,
    p3: `Gość`,
    p4: `Data zapytania`,
    p5: `Nie złożono jeszcze żadnych zapytań o usługi`,
    p6: `Nie skonfigurowano jeszcze żadnych usług.`,
    p7: `Warto skonfigurować usługi obiektu, aby goście mogli składać zapytania`,
    p8: `Skonfiguruj usługę`,
    p9: `Konsultacja`,
    p10: `Usuń zapytanie o usługę`,
    p11: `Czy na pewno? Dane zapytania zostaną utracone`,
    p12: `Usuń`,
    p13: `Zapytanie o usługę zostało usunięte`,
    p14: "Dodaj maksymalnie 3 zdjęcia usługi",
    p15: "Przeciągnij i upuść, aby dodać zdjęcia",
    p16: "...lub kliknij, aby wybrać zdjęcia z komputera",
    p17: "Kliknij, aby wybrać zdjęcie z galerii"
};
